import { Modal, Select, message } from 'antd';
import React, { Component } from 'react';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

const Option = Select.Option;

export default class Copy extends Component {
    state = {
        visible: false,
        currentGroupingId: '',
        targetGroupingId: '',
        visitGroupingList: [],
    }

    show = (visitGroupingList, activeKey) => {
        this.setState({
            visible: true,
            visitGroupingList,
            currentGroupingId: activeKey,
        })
    }

    hide = () => {
        this.setState({
            visible: false,
            currentGroupingId: '',
            targetGroupingId: '',
            visitGroupingList: [],
        })
    }

    sumbit = () => {
        const { currentGroupingId, targetGroupingId } = this.state;
        if (!targetGroupingId) {
            message.warning('复制对象不能为空！');
        }
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.copyEvaluateVisit,
            data: { currentGroupingId, targetGroupingId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    visible: false,
                },() => {
                    message.success(res.data.success);
                    this.props.updateCopyData();
                })
            },
        });
    }

    handleChange = (value) => {
        this.setState({
            targetGroupingId: value,
        })
    }

    render() {
        const { visible, targetGroupingId, currentGroupingId, visitGroupingList = [] } = this.state;
        let currentGroupingName = '';
        visitGroupingList.map(el => {
            if (el.visitGroupingId == currentGroupingId) {
                currentGroupingName = el.visitGroupingName
            }
        });
        const targetGroupingOptions = visitGroupingList.filter(el => el.haveVisitStage).map(el => <Option key={el.visitGroupingId} value={el.visitGroupingId}>{el.visitGroupingName}</Option>);
        return (
            <Modal
                title={'复制访视方案'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.sumbit}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={400}
            >   
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 10}}>
                            <div className="item-left" style={{width: 120, paddingRight: 10}}>
                                复制对象：
                            </div>
                            <div className="item-right" style={{width: 182}}>
                                <Select
                                    style={{width: 140}}
                                    allowClear
                                    placeholder='请选择'
                                    value={targetGroupingId}
                                    onChange={value => this.handleChange(value)}
                                >
                                    {targetGroupingOptions}
                                </Select>
                            </div>
                        </li>
                        <li className="modal-item" style={{paddingBottom: 10}}>
                            <div className="item-left" style={{width: 120, paddingRight: 10}}>
                                访视方案名称：
                            </div>
                            <div className="item-right" style={{width: 182}}>
                                {currentGroupingName}
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitPeriodPlan/components/Copy.js